"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_75_20_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const applyArticleSpecs = (kette) => {
    if (kette.IproProduktgruppenId) {
        // twisterband
        if (echain_shared_articles_1.TwisterbandIproProduktgruppenIds[kette.IproProduktgruppenId]) {
            kette.ArticleSpecs = [...(kette.ArticleSpecs || []), 'twisterband'];
        }
        // twisterchain
        if (echain_shared_articles_1.TwisterchainIproProduktgruppenIds[kette.IproProduktgruppenId]) {
            kette.ArticleSpecs = [...(kette.ArticleSpecs || []), 'twisterchain'];
        }
        // triflexR
        if (echain_shared_articles_1.TriflexRIproProduktgruppenIds[kette.IproProduktgruppenId]) {
            kette.ArticleSpecs = [...(kette.ArticleSpecs || []), 'triflexR'];
        }
        // rxRohr
        if (echain_shared_articles_1.RXIproProduktgruppenIds[kette.IproProduktgruppenId]) {
            kette.ArticleSpecs = [...(kette.ArticleSpecs || []), 'rxRohr'];
        }
        // eskin
        if (echain_shared_articles_1.ESkinIproProduktgruppenIds[kette.IproProduktgruppenId]) {
            kette.ArticleSpecs = [...(kette.ArticleSpecs || []), 'eskin'];
        }
    }
};
/**
 * Migrate to 75.20.0
 *
 * Adds proper ArticleSpecs for special ketten (also handles espool child ketten)
 */
const migration_75_20_0 = (json) => {
    var _a;
    if (json === null || json === void 0 ? void 0 : json.Kette)
        applyArticleSpecs(json.Kette);
    if (json === null || json === void 0 ? void 0 : json.Espool) {
        (_a = json.Children) === null || _a === void 0 ? void 0 : _a.forEach((childConfig) => {
            if (childConfig === null || childConfig === void 0 ? void 0 : childConfig.Kette)
                applyArticleSpecs(childConfig.Kette);
        });
    }
    return json;
};
exports.migration_75_20_0 = migration_75_20_0;
//# sourceMappingURL=migration_75_20_0.js.map